
<template>
    <div id="profile-page">

        <!-- COL AREA -->
        <div class="vx-row">
            <!-- COL 1 -->
            <div class="vx-col w-full lg:w-1/4">
                <vx-card title="ListPegawai" class="mt-base">
                    <!-- ACTION SLOT -->
                    <template slot="actions">
                        <feather-icon icon="UsersIcon"></feather-icon>
                    </template>
                    <div id="list-listpegawai">
                      <vs-table ref="table" pagination :max-items="itemsPerPage" :data="listpegawais" search>

                        <template slot-scope="{data}">
                          <tbody>
                            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

                              <vs-td>
                                <vs-avatar class="m-0" :src="getImage('/profil/'+tr.avatar)" size="35px"></vs-avatar>
                              </vs-td>

                              <vs-td>
                                <p class="font-medium">{{ tr.nama }}</p>
                                <span class="text-xs">{{ tr.namestruktur }}</span>
                              </vs-td>

                              <vs-td>
                                <vs-button radius color="primary" type="border" icon="search" @click="pilihKi(tr)" size="small"></vs-button>
                              </vs-td>

                            </vs-tr>
                          </tbody>
                        </template>
                      </vs-table>
                    </div>
                </vx-card>

            </div>

            <!-- COL 2 -->
            <template v-if="pilihPegawai">
            <div class="vx-col w-full lg:w-3/4">
              <div class="vx-row">
                <div class="vx-col w-full">
                  <vx-card title="" class="mt-base">
                      <div class="post-header">
                        <div class="vx-row">
                          <div class="vx-col w-full lg:w-2/5">
                            <div class="flex items-center">
                              <div>
                                  <vs-avatar class="m-0" :src="getImage('/profil/'+pegawaiAvatar)" size="85px"></vs-avatar>
                              </div>
                              <div class="ml-5">
                                  <h3>{{ pegawaiNama }}</h3>
                                  <p>{{ pegawaiID }}</p>
                                  <p>{{ pegawaiStruktur }}</p>
                              </div>
                            </div>
                          </div>
                          <div class="vx-col w-full lg:w-1/5 flex">
                            <div class="flex items-center">
                              <div>
                                  <h5 class="mb-3">Absensi {{ pegawaiTenaga }}</h5>
                                  <h5>Kantor {{ pegawaiKantor }}</h5>
                              </div>
                            </div>
                          </div>
                          <div class="vx-col w-full lg:w-1/5 flex">
                            <div class="flex items-center">
                              <div>
                                  <h5 class="mb-3">{{ pegawaiPonsel }}</h5>
                                  <h5>{{ pegawaiEmail }}</h5>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                  </vx-card>
                </div>
              </div>

              <vs-prompt title="Export To Excel" class="export-options" @cancle="clearFields" @accept="exportToExcel" accept-text="Export" @close="clearFields" :active.sync="activePrompt">
                  <vs-input v-model="fileName" placeholder="Enter File Name.." class="w-full" />
                  <v-select v-model="selectedFormat" :options="formats" class="my-4" />
                  <div class="flex">
                    <span class="mr-4">Cell Auto Width:</span>
                    <vs-switch v-model="cellAutoWidth">Cell Auto Width</vs-switch>
                  </div>
              </vs-prompt>

              <vx-card class="mt-base">
                <div id="table-absen">
                  <vs-table ref="tableTask" v-model="selected" :data="task" search>
                    <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

                      <div class="flex flex-wrap-reverse items-center data-list-btn-container">

                        <vs-button color="primary" type="filled" icon="archive" @click="activePrompt=true" class="mr-4">Export</vs-button>

                      </div>

                      <div class="pb-3 mr-4">
                        <vs-button @click="submitFilter(task)" :disabled="!isFilterTanggal" class="mr-2">Filter</vs-button>
                        <flat-pickr v-model="filterTanggal" name="Mulai" v-validate="'required'" :config="config"/>
                      </div>
                    </div>

                    <template slot="thead">
                      <vs-th sort-key="tanggal" class="text-center">Hari</vs-th>
                      <vs-th sort-key="tanggal" class="text-center">Tanggal</vs-th>
                      <vs-th sort-key="masuk" class="text-center">Masuk</vs-th>
                      <vs-th sort-key="pulang" class="text-center">Pulang</vs-th>
                      <vs-th sort-key="lambat" class="text-center">Datang Lambat</vs-th>
                      <vs-th sort-key="pulangcepat" class="text-center">Pulang Cepat</vs-th>
                      <vs-th sort-key="total" class="text-center">Total Jam Kerja</vs-th>
                      <vs-th sort-key="lembur" class="text-center">Lembur</vs-th>
                      <vs-th sort-key="siang" class="text-center">Siang</vs-th>
                      <vs-th sort-key="keterangan" class="text-center">Absen</vs-th>
                      <vs-th sort-key="lokasi" class="text-center">Lokasi</vs-th>
                    </template>

                    <template slot-scope="{data}">
                      <tbody>
                        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" :state="tr.classes">

                          <vs-td>
                            <p class="font-medium truncate">{{ tr.hari }}</p>
                          </vs-td>

                          <vs-td>
                            <p class="font-medium truncate">{{ tr.tanggal }}</p>
                          </vs-td>

                          <vs-td>
                            <p class="font-medium truncate">{{ tr.masuk }}</p>
                          </vs-td>
                          
                          <vs-td>
                            <p class="font-medium truncate">{{ tr.pulang }}</p>
                          </vs-td>
                          
                          <vs-td>
                            <p class="font-medium truncate">{{ tr.datang_lambat }}</p>
                          </vs-td>
                          
                          <vs-td>
                            <p class="product-name font-medium truncate">{{ tr.pulang_cepat }}</p>
                          </vs-td>
                          
                          <vs-td>
                            <p class="product-name font-medium truncate">{{ tr.total_jam }}</p>
                          </vs-td>
                          
                          <vs-td>
                            <p class="product-name font-medium truncate">{{ tr.lembur }}</p>
                          </vs-td>

                          <vs-td>
                            <p class="font-medium truncate">{{ tr.siang }}</p>
                          </vs-td>
                          
                          <vs-td>
                            <p class="product-name font-medium truncate">{{ tr.keterangan }}</p>
                          </vs-td>
                          
                          <vs-td>
                            <p class="product-name font-medium truncate">{{ tr.lokasi }}</p>
                          </vs-td>

                          
                          <template class="expand-user" slot="expand">
                            <template v-if="tr.masuk != 'Libur' && tr.masuk != 'Tidak Hadir'">
                              <vx-card>
                                  <div class="post-header">
                                    <div class="vx-row">
                                      <div class="vx-col w-full lg:w-1/2">
                                        <div class="flex items-center">
                                          <div>
                                              <img class="m-0" :src="getImage('/media/'+tr.mulai_foto)"/>
                                          </div>
                                          <div class="ml-5">
                                              <h4>Foto Masuk</h4>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="vx-col w-full lg:w-1/2 flex">
                                        <div class="flex items-center">
                                          <div>
                                              <img class="m-0" :src="getImage('/media/'+tr.selesai_foto)"/>
                                          </div>
                                          <div class="ml-5">
                                              <h4>Foto Selesai</h4>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                              </vx-card>
                            </template>
                            <template v-else>
                              <vx-card></vx-card>
                            </template>
                          </template>

                        </vs-tr>
                      </tbody>
                    </template>
                  </vs-table>
                </div>
              </vx-card>
            </div>
            </template>
            <template v-else>
              <div class="vx-col w-full lg:w-3/4">
                <p class="mt-base">
                  <span>{{ keterangan }}</span>
                </p>
              </div>
            </template>

        </div>
    </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import listpegawaiModule from '@/stores/rekap/absensi-pegawai.js'
//import moment from 'moment'
import vSelect from 'vue-select'

export default {
  components: {
    flatPickr,
    vSelect
  },
  data () {
    return {
      selected: [],
      itemsPerPage: 8,
      isMounted: false,
      pilihPegawai: false,
      keterangan: 'PILIH PEGAWAI',

      pegawaiAvatar : null,
      pegawaiNama : null,
      pegawaiIDStruktur : null,
      pegawaiStruktur : null,
      pegawaiTenaga : null,
      pegawaiKantor : null,
      pegawaiPonsel : null,
      pegawaiEmail : null,
      pegawaiID: null,
      pegawaiUserID : null,

      currentPageTask : 0,
      itemsPerPageTask: 10,
      task : [],

      config: {
        mode: 'range'
      },
      filterTanggal: null,
      isNavOpen: false,
      wasSidebarOpen: null,

      filterMin: 'empty',
      filterMax: 'empty',

      // export

      fileName: '',
      formats:['xlsx', 'csv', 'txt'],
      cellAutoWidth: true,
      selectedFormat: 'xlsx',
      headerTitle: ["Hari", "Tanggal", "Masuk", "Siang", "Pulang", "Datang Lambat", "Pulang Cepat", "Total Jam", "Lembur", "Keterangan", "Lokasi"],
      headerVal: ["hari", "tanggal", "masuk", "siang", "pulang", "datang_lambat", "pulang_cepat", "total_jam", "lembur", "keterangan", "lokasi"],
      activePrompt: false
    }
  },
  computed: {
    isFilterTanggal () {
      return !this.errors.any() && this.filterTanggal
    },
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    listpegawais () {
      return this.$store.state.listpegawai.listpegawais
    },
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.listpegawais.length
    }
  },
  methods: {
    loadContent () {
      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: '#button-load-more-posts',
        scale: 0.45
      })
      setTimeout(() => {
        this.$vs.loading.close('#button-load-more-posts > .con-vs-loading')
      }, 3000)
    },
    pilihKi(dataPilih) {
      this.$vs.loading()
      this.pilihPegawai = false
      this.keterangan = 'Loading..'
      this.pegawaiUserID = dataPilih.user_id
      this.task = []
      this.loadTask(dataPilih.user_id, dataPilih.struktur)
      setTimeout(() => {
        this.pegawaiAvatar = dataPilih.avatar
        this.pegawaiNama = dataPilih.nama
        this.pegawaiStruktur = dataPilih.namestruktur
        this.pegawaiIDStruktur = dataPilih.struktur
        this.pegawaiTenaga = dataPilih.nametenaga
        this.pegawaiKantor = dataPilih.namekantor
        this.pegawaiPonsel = dataPilih.ponsel
        this.pegawaiEmail = dataPilih.email
        this.pegawaiID = dataPilih.idpegawai
        this.pilihPegawai = true
        this.task = this.$store.state.listpegawai.taskpegawais
        this.queriedItemsTask = this.$refs.tableTask ? this.$refs.tableTask.queriedResults.length : this.task.length
        this.$vs.loading.close()
      }, 3000) 
    },
    loadTask(user_id, struktur) {
      let pilihSet = {
        user : user_id,
        struktur : struktur,
        min : this.filterMin,
        max : this.filterMax
      }
      this.$store.dispatch('listpegawai/fetchTaskPegawai', pilihSet)
      .catch(error => { 
        this.$vs.notify({
          color  : 'danger',
          text  : error.message,
        })
      })
    },
    submitFilter() {
      this.$vs.loading()
      this.task = []
      let rangeTanggal = this.filterTanggal.split(' to ');
      this.filterMin = rangeTanggal[0]
      this.filterMax = rangeTanggal[1]
      this.loadTask(this.pegawaiUserID, this.pegawaiIDStruktur, this.filterMin, this.filterMax)
      setTimeout(() => {
        this.task = this.$store.state.listpegawai.taskpegawais
        this.queriedItemsTask = this.$refs.tableTask ? this.$refs.tableTask.queriedResults.length : this.task.length
        this.$vs.loading.close()
      }, 3000)
    },
    initPilih() {
      this.pegawaiAvatar = null
      this.pegawaiNama = null
      this.pegawaiIDStruktur = null
      this.pegawaiStruktur = null
      this.pegawaiTenaga = null
      this.pegawaiKantor = null
      this.pegawaiPonsel  = null
      this.pegawaiEmail  = null
      this.pegawaiID = null
    },

    // export

    exportToExcel () {
      import('@/vendor/Export2Excel').then(excel => {
        const list = this.task
        const data = this.formatJson(this.headerVal, list)
        excel.export_json_to_excel({
          header: this.headerTitle,
          data,
          filename: this.fileName,
          autoWidth: this.cellAutoWidth,
          bookType: this.selectedFormat
        })
        this.clearFields()
      })
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        // Add col name which needs to be translated
        // if (j === 'timestamp') {
        //   return parseTime(v[j])
        // } else {
        //   return v[j]
        // }

        return v[j]
      }))
    },
    clearFields () {
      this.filename = ''
      this.cellAutoWidth = true
      this.selectedFormat = 'xlsx'
    }
  },
  mounted () {
    this.wasSidebarOpen = this.$store.state.reduceButton
    this.$store.commit('TOGGLE_REDUCE_BUTTON', true)
    this.isMounted = true
  },
  beforeDestroy () {
    if (!this.wasSidebarOpen) this.$store.commit('TOGGLE_REDUCE_BUTTON', false)
  },
  created () {
    if (!listpegawaiModule.isRegistered) {
      this.$store.registerModule('listpegawai', listpegawaiModule)
      listpegawaiModule.isRegistered = true
    }
    this.$store.dispatch('listpegawai/fetchListPegawai')
    .catch(error => { 
      this.$vs.notify({
        color  : 'danger',
        text  : error.message,
      })
    })
  },
}

</script>


<style lang="scss">
@import "@/assets/scss/vuexy/pages/profile.scss";
#table-absen {
  .vs-con-table {

    .vs-con-tbody {
      background: none;
      border: none;
    }

    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }

    .tr-expand td .content-tr-expand {
      padding : 0;
      padding-right: 0;
      border-top: none;
    }
  }
}
#list-listpegawai {
  .vs-con-table {

    .vs-con-tbody {
      background: none;
      border: none;
    }

    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        margin: auto;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      min-width : auto;

      tr{
          box-shadow: none;
          td{
            padding: 15px 0;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
